import _ from 'lodash'

export function parseStreamingServiceError (error) {
  let message = 'Something went wrong!'
  if (_.isArray(error.error)) {
    message = _.isObject(error.error[0]) ? error.error[0].message : error.error[0]
  }
  return message
}
